import { generateQuoteObject } from "./quotes";
import { getBrokerDetails } from "./broker";
import jwtInterceptor from "../helper/jtwInterceptor";
import { format } from "date-fns";
import { endpoints } from "../helper/endpoints";
import { RegionData } from "../shared/types/regionData";

/**
 * Function to create a new quote with provided client information, products, packages, and values.
 * @param {any} quoteClient - Client information for the quote.
 * @param {any} products - List of products to be included in the quote.
 * @param {any} packages - List of packages to be included in the quote.
 * @param {any} values - Additional values and information for the quote.
 * @returns {Promise} A Promise that resolves with the created quote data if successful.
 */
export const createQuote = async (quoteClient: any, products: any, packages: any, values: any, ratingRegionsRows: RegionData[]) => {
	// Retrieve the broker's ID from local storage.
	const brokerId = localStorage.getItem("brokerId");

	// Fetch broker details using the broker's ID.
	const brokerData = await getBrokerDetails(brokerId);

	// Create a new quote object with client and broker information.
	const newQuoteObject = {
		id: 0, // Quote ID (initialized as 0 for a new quote).
		readOnly: true,
		quoteClient: quoteClient,
		quoteBroker: {
			id: parseInt(brokerId ?? "0"),
			brokerFirm: null,
			email: brokerData.email,
			firstName: brokerData.firstName,
			lastName: brokerData.lastName,
		},
		quotes: [],
	};

	let startDate = format(new Date(values.startDate), "yyyy-MM-dd'T00:00:00'");
	let endDate = format(new Date(values.endDate), "yyyy-MM-dd'T00:00:00'");

	let quotes = products
		.concat(packages)
		.map((item: any) => generateQuoteObject(item, values, ratingRegionsRows))
		.map((q: any) => {
			return { ...q, policyPeriodStartDate: startDate, policyPeriodEndDate: endDate };
		});

	console.log("New quote object", {
		...newQuoteObject,
		quotes: quotes,
	});

    return {
        ...newQuoteObject,
        quotes: quotes,
    };
	// return await jwtInterceptor({
	// 	method: "post",
	// 	url: endpoints.CREATE_QUOTE_GROUP,
	// 	// url: "https://u090h4woii.execute-api.ap-southeast-2.amazonaws.com/delta-microservices/quote-create-quote-group",
	// 	data: JSON.stringify({
	// 		...newQuoteObject,
	// 		quotes: quotes,
	// 	}),
	// 	headers: {
	// 		"Content-Type": "application/json",
	// 	},
	// })
	// 	.then((response: any) => {
	// 		console.log("Created quote", response.data);
	// 		return response.data;
	// 	})
	// 	.catch((error: any) => {
	// 		console.log("Error creating quote", error);
	// 		return error;
	// 	});
};
